<template>
  <v-row>
    <v-col cols="12">
      <peopleList
        :me="me"
      ></peopleList>
    </v-col>
  </v-row> 
</template>

<script>
import peopleList from "../../components/PeopleList.vue";
export default {
  components: {
    peopleList
  },
  props: ["me"],
  data() {
    return {
    };
  },
  methods: {
  },
  mounted() {
  }
};
</script>